import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoFinanciamientoGeneradorComponent () {
  var $ctrl = this

  $ctrl.aceptar = aceptar
  $ctrl.cerrar = cerrar
  $ctrl.config = {
    plazo_cantidad: $ctrl.plazoCantidad || undefined,
    plazo_inicio: $ctrl.plazoInicio || new Date(),
    plazo_tipo: 30,
  }
  $ctrl.catalogos = {
    plazo_tipo: [
      {id: 7, descripcion: 'Semanas'},
      {id: 15, descripcion: 'Quincenas'},
      {id: 30, descripcion: 'Meses'},
    ],
  }

  function aceptar () {
    var importe = $ctrl.data.importe,
      interes = $ctrl.data.interes,
      capital = $ctrl.data.capital,
      plazo_cantidad = $ctrl.config.plazo_cantidad,
      plazo_tipo = $ctrl.config.plazo_tipo,
      fecha = new Date($ctrl.config.plazo_inicio),
      financiamiento = [],
      total = {
        importe: 0,
        interes: 0,
        capital: 0,
      }

    for (let i = 1; i <= plazo_cantidad; i++) {
      var pago = {
        indice: i,
        fecha: new Date(fecha),
        notas: $ctrl.data.financiamiento[i - 1] && $ctrl.data.financiamiento[i - 1].notas || '',
      }

      pago.importe = parseFloat((importe / plazo_cantidad).toFixed(2))
      pago.interes = parseFloat((interes / plazo_cantidad).toFixed(2))
      pago.capital = parseFloat((capital / plazo_cantidad).toFixed(2))

      total.importe += pago.importe
      total.interes += pago.interes
      total.capital += pago.capital

      fecha.setDate(fecha.getDate() + plazo_tipo)

      financiamiento.push(pago)
    }

    cerrar(financiamiento)
  }

  function cerrar (data) {
    $ctrl.onClose({$event: {data: data}})
  }
}

module.component('financesPosicionbancariaPrestamoFinanciamientoGenerador', {
  controller: FinancesPosicionbancariaPrestamoFinanciamientoGeneradorComponent,
  template,
  bindings: {
    data: '<',
    plazoCantidad: '<',
    plazoInicio: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/financiamiento/generador/component.js